/** Visual ordering for the Repair Order activity timeline. Audit rows are not rewritten. */

export const RO_ACTIVITY_PREVIEW_COUNT = 5;

export type RoActivityStamp = {
  id?: number;
  createdAt: string | Date;
};

export function sortRoActivityNewestFirst<T extends RoActivityStamp>(entries: readonly T[]): T[] {
  return [...entries].sort((a, b) => {
    const delta = new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    if (delta !== 0) return delta;
    return (b.id ?? 0) - (a.id ?? 0);
  });
}

export function roActivityWindow<T>(entries: readonly T[], expanded: boolean, limit = RO_ACTIVITY_PREVIEW_COUNT) {
  const hidden = Math.max(0, entries.length - limit);
  const showingAll = expanded || hidden === 0;
  return {
    visible: showingAll ? [...entries] : entries.slice(0, limit),
    hiddenCount: showingAll ? 0 : hidden,
    canExpand: hidden > 0 && !expanded,
    canCollapse: hidden > 0 && expanded,
    expandLabel: hidden === 1 ? "Show 1 older event" : `Show ${hidden} older events`,
    collapseLabel: "Show less",
    total: entries.length,
  };
}
